import * as API from "./api";

export { API };